"use client";

import { useState, useCallback, useEffect } from "react";

import { apiFetch } from "@/lib/api";

export type AssessmentSummary = {
  id: string;
  title: string;
  current_stage: string;
  updated_at: string;
};

export function useAssessments() {
  const [assessments, setAssessments] = useState<AssessmentSummary[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await apiFetch("/chat/sessions");
      if (!response.ok) throw new Error("Failed to fetch assessments");
      const data = await response.json();
      setAssessments(data);
      setError(null);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    assessments,
    isLoading,
    error,
    refresh,
  };
}
